import React from "react";
import { Navbar, Nav, Container, Button, NavDropdown } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import 'bootstrap/dist/css/bootstrap.min.css';
import './JobSeekerNavbar.css';
import Logo from '../Images/GudnetNewLogo.webp'

const JobSeekerNavbar = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language || "en";
  const navigate = useNavigate();
  const location = useLocation();
  const handleLoginClick = () => navigate("/login");
  const handleRegister = () => navigate("/register");
  const isActive = (path) => location.pathname === path;
  const isHealthcareActive = ["/nurse", "/doctor"].includes(location.pathname);

  // Check if any dropdown item is active
  const isDropdownActive = () => {
    const dropdownPaths = [
      "/aboutus", "/contactus", "/tips-news", "/training", "/faqs",
      "/terms-and-conditions", "/privacy-policy", "/returns-refunds-cancellation",
      "/shipping-delivery-policy"
    ];
    return dropdownPaths.some(path => isActive(path));
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <Navbar expand="xl" bg="white" variant="light" fixed="top" className="shadow-sm py-2 custom-navbar">
      <Container>
        <Navbar.Brand href="/" className="d-flex align-items-center">
          <img
            src={Logo}
            alt="Gudnet Logo"
            style={{ height: '50px', objectFit: 'contain' }}
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="main-navbar" />
        <Navbar.Collapse id="main-navbar">
          <Nav className="mx-auto nav-links">
            <Nav.Link href="/" className={isActive("/") ? "active-nav" : "nav-link-custom"}>
              {t("navbar.home")}
            </Nav.Link>
            <Nav.Link
              href="/alljobs"
              className={isActive("/alljobs") || isActive("/alljobdetails") ? "active-nav" : "nav-link-custom"}
            >
              {t("navbar.jobs")}
            </Nav.Link>
            <Nav.Link
              href="/domestichelper"
              className={isActive("/domestichelper") ? "active-nav" : "nav-link-custom"}
            >
              {t("navbar.domestic_staff")}
            </Nav.Link>
            <Nav.Link
              href="/driver"
              className={isActive("/driver") ? "active-nav" : "nav-link-custom"}
            >
              {t("navbar.driver")}
            </Nav.Link>

            <NavDropdown
              title={t("navbar.healthcare")}
              id="healthcare-dropdown"
              className={`news-dropdown healthcare-dropdown ${isHealthcareActive ? "active-nav" : "nav-link-custom"}`}
            >
              <NavDropdown.Item href="/nurse" className={isActive("/nurse") ? "dropdown-active" : ""}>
                {t("navbar.nurse")}
              </NavDropdown.Item>
              <NavDropdown.Item href="/doctor" className={isActive("/doctor") ? "dropdown-active" : ""}>
                {t("navbar.doctor")}
              </NavDropdown.Item>
            </NavDropdown>

            <Nav.Link
              href="/jobineurope"
              className={isActive("/jobineurope") ? "active-nav" : "nav-link-custom"}
            >
              {t("navbar.jobs_in_europe")}
            </Nav.Link>
            <Nav.Link
              href="/cook"
              className={isActive("/cook") ? "active-nav" : "nav-link-custom"}
            >
              {t("navbar.company_worker")}
            </Nav.Link>
            <Nav.Link
              href="/agencies"
              className={isActive("/agencies") ? "active-nav" : "nav-link-custom"}
            >
              {t("navbar.agency")}
            </Nav.Link>

            {/* ✅ Updated Dropdown Menu */}
            <NavDropdown
              title={t("navbar.contact_us")}
              id="info-dropdown"
              className={`news-dropdown ${isDropdownActive() ? "active-nav" : "nav-link-custom"}`}
            >
              <NavDropdown.Item href="/aboutus" className={isActive("/aboutus") ? "dropdown-active" : ""}>{t("navbar.about_us")}</NavDropdown.Item>
              <NavDropdown.Item href="/contactus" className={isActive("/contactus") ? "dropdown-active" : ""}>{t("navbar.contact_us")}</NavDropdown.Item>
              <NavDropdown.Item href="/tips-news" className={isActive("/tips-news") ? "dropdown-active" : ""}>{t("navbar.tips_news")}</NavDropdown.Item>
              <NavDropdown.Item href="/training" className={isActive("/training") ? "dropdown-active" : ""}>{t("navbar.training")}</NavDropdown.Item>
              <NavDropdown.Item href="/faqs" className={isActive("/faqs") ? "dropdown-active" : ""}>{t("navbar.faqs")}</NavDropdown.Item>
              <NavDropdown.Item href="/terms-and-conditions" className={isActive("/terms-and-conditions") ? "dropdown-active" : ""}>{t("navbar.terms_conditions")}</NavDropdown.Item>
              <NavDropdown.Item href="/privacy-policy" className={isActive("/privacy-policy") ? "dropdown-active" : ""}>{t("navbar.privacy_policy")}</NavDropdown.Item>
              <NavDropdown.Item href="/returns-refunds-cancellation" className={isActive("/returns-refunds-cancellation") ? "dropdown-active" : ""}>
                {t("navbar.returns_policy")}
              </NavDropdown.Item>
              <NavDropdown.Item href="/shipping-delivery-policy" className={isActive("/shipping-delivery-policy") ? "dropdown-active" : ""}>
                {t("navbar.shipping_policy")}
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>

          {/* Buttons moved inside Navbar.Collapse for mobile */}
          <div className="navbar-buttons d-flex align-items-center">
            <NavDropdown
              title={
                <span>
                  <i className="bi bi-globe me-1"></i>
                  {currentLanguage.startsWith("ar") ? "العربية" : "English"}
                </span>
              }
              id="language-dropdown"
              className="language-dropdown-custom me-2"
            >
              <NavDropdown.Item onClick={() => changeLanguage('en')} active={currentLanguage.startsWith('en')}>
                English
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => changeLanguage('ar')} active={currentLanguage.startsWith('ar')}>
                العربية
              </NavDropdown.Item>
            </NavDropdown>

            <Button
              variant="outline-success"
              className="login-btn-outline fw-semibold px-4"
              onClick={handleLoginClick}
            >
              {t("navbar.login")}
            </Button>
            <Button variant="success" className="register-btn" onClick={handleRegister}>
              {t("navbar.register")}
            </Button>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default JobSeekerNavbar;
